import React, { useMemo } from 'react';

const GROUP_ORDER = ['Regions', 'Copy', 'Brand', 'Blocks', 'Photos'];

const MediaCreatorLayersTree = ({
  entries,
  selectedElementKey,
  selectedPhotoSlot,
  onSelectKey,
  onSelectPhotoSlot,
}) => {
  const grouped = useMemo(() => {
    const map = new Map();
    (entries || []).forEach((e) => {
      if (!map.has(e.group)) map.set(e.group, []);
      map.get(e.group).push(e);
    });
    return GROUP_ORDER.filter((g) => map.has(g)).map((g) => ({ group: g, items: map.get(g) }));
  }, [entries]);

  const pick = (entry) => {
    if (entry.kind === 'photo') {
      onSelectPhotoSlot?.(entry.key.slice(5));
      onSelectKey?.(null);
      return;
    }
    onSelectKey?.(entry.key);
    if (entry.key.startsWith('slot:')) {
      onSelectPhotoSlot?.(entry.key.slice(5));
    } else {
      onSelectPhotoSlot?.(null);
    }
  };

  const isOn = (entry) => {
    if (entry.kind === 'photo') return selectedPhotoSlot === entry.key.slice(5);
    return selectedElementKey === entry.key;
  };

  return (
    <div className="mc-layers-tree">
      {grouped.map(({ group, items }) => (
        <div key={group} className="mc-layers-group">
          <h5 className="mc-layers-group-title">{group}</h5>
          <ul>
            {items.map((entry) => (
              <li key={entry.key}>
                <button
                  type="button"
                  className={isOn(entry) ? 'on' : ''}
                  onClick={() => pick(entry)}
                >
                  {entry.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default MediaCreatorLayersTree;
